// extracted by mini-css-extract-plugin
module.exports = {"container":"ToolbarColorPicker_container__1U10X","colorPickerContainer":"ToolbarColorPicker_colorPickerContainer__SRGz9"};